import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ContentPath } from './content-path';
import { ContentHeaderService } from './content-header.service';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.less'],
  standalone: false,
})
export class ContentHeaderComponent implements OnInit, OnDestroy {
  showContentHeader = false;
  title = 'Dashboard';
  subtitle = '...';
  contentsPath: ContentPath[] = [];
  contentId = '';
  loading = false;

  private readonly subs = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly contentHeaderService: ContentHeaderService,
  ) { }

  ngOnInit(): void {
    this.subs.add(
      this.contentHeaderService.getState().subscribe((state) => {
        this.title = state.title;
        this.subtitle = state.subtitle;
        this.showContentHeader = state.showContentHeader;
        this.contentsPath = state.contentsPath;
        this.contentId = state.contentId;
        this.loading = state.loading;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onBreadcrumbClick(args: BreadcrumbClickEventArgs): void {
    args.cancel = true;

    if (!args.item.url) {
      return;
    }

    this.router.navigateByUrl(args.item.url);
  }
}
